import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BrandingField } from "./BrandingField";

export function ContentTab() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Home hero</CardTitle>
          <CardDescription>
            The top section on the marketing home page — headline, supporting
            copy, CTA button, and background image.
          </CardDescription>
        </CardHeader>
        <CardContent className="grid gap-5 sm:grid-cols-2">
          <div className="sm:col-span-2">
            <BrandingField
              brandingKey="hero.headline"
              label="Headline"
              placeholder="Catering crafted with care"
            />
          </div>
          <div className="sm:col-span-2">
            <BrandingField
              brandingKey="hero.subheadline"
              label="Subheadline"
              multiline
              placeholder="One-sentence supporting line."
            />
          </div>
          <BrandingField
            brandingKey="hero.cta_text"
            label="CTA button text"
            placeholder="Plan Your Event"
          />
          <BrandingField
            brandingKey="hero.image_url"
            label="Hero image URL"
            type="url"
            placeholder="https://..."
            description="Paste a URL or leave blank to use the default."
          />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Footer</CardTitle>
          <CardDescription>
            Legal line and social links. Leave social URLs blank to hide the
            icons.
          </CardDescription>
        </CardHeader>
        <CardContent className="grid gap-5 sm:grid-cols-2">
          <div className="sm:col-span-2">
            <BrandingField
              brandingKey="footer.legal_text"
              label="Legal / copyright line"
              placeholder="© Tristano's Catering. All rights reserved."
            />
          </div>
          <BrandingField
            brandingKey="footer.social_facebook"
            label="Facebook URL"
            type="url"
            placeholder="https://facebook.com/..."
          />
          <BrandingField
            brandingKey="footer.social_instagram"
            label="Instagram URL"
            type="url"
            placeholder="https://instagram.com/..."
          />
        </CardContent>
      </Card>
    </div>
  );
}
